<template>
  <BasePanelWithHeader headerText="Priorities">
    <template v-slot:content>
      <v-row>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.luPriorityForm.addLuPriority()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Priority
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="luPriorities"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.luPriorityForm.editLuPriority(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit Priority
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.luPriorityDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete Priority
          </BaseTooltipButton>
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="luPriorityDelete"
        :delete="deleteLuPriority"
        @refresh="clearLookupCacheAndReloadLuPriorities"
      >
        Are you sure you want to delete this priority?
      </BaseDeleteConfirm>
      <LuPriorityDialogForm
        ref="luPriorityForm"
        @refresh="clearLookupCacheAndReloadLuPriorities"
      >
      </LuPriorityDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuPriorityDialogForm from '@components/form/add-edit/LuPriorityDialog'
export default {
  components: {
    LuPriorityDialogForm,
  },
  data: () => ({
    searchText: '',
  }),
  created() {
    this.loadLuPriorities()
  },
  computed: {
    ...get('luPriority', ['luPriorities', 'loading']),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'Description',
          align: 'center',
          sortable: true,
          value: 'Description',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: true,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('luPriority', [
      'deleteLuPriority',
      'loadLuPriorities',
      'clearLookupCacheAndReloadLuPriorities',
    ]),
  },
}
</script>
<style>
</style>